import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "../../css/dashboard.css";
import axios from 'axios';
import CommonTable from "../component/table_list/common_table";
import CommonTableRow from "../component/table_list/common_tablerow";
import CommonTableColumn from "../component/table_list/common_tablecolumn";
import Pagination from "react-js-pagination";
import styled from "styled-components"
import Menu from "../component/main_menu"
import { formatDate } from "../utils/format_date"
import { useAuthContext } from '../common/ProtectedLayout';

function TodayReserve(props) {

    const location = useLocation();
    const navigate = useNavigate();
    const [isValidAccess, setIsValidAccess] = useState(false); // 유효한 접근 상태
    const [reserveList, setReserveList] = useState([]);
    const [reserveCount, setReserveCount] = useState([]);
    const [page, setPage] = useState(1);
    const items = 10;
    const hadlePageChange = (page) => { setPage(page) };
    const auth = useAuthContext();

    const getReservationToday = async () => {
        try {
            const getPage = (page - 1) * 10;
            const reserve_result = await axios.get(`/Reservation/Today/${getPage}`);
            setReserveList(reserve_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    };
    const getReserveCount = async () => {
        try {
            const reserve_result = await axios.get('/Reservation/TodayCount');
            setReserveCount(reserve_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    }

    useEffect(() => {
        getReservationToday();
    }, [page])

    useEffect(() => {
        setIsValidAccess(true);
        getReserveCount();
        getReservationToday();
    }, [location.state, navigate]);

    // 유효한 접근이 아닌 경우 렌더링하지 않음
    if (!isValidAccess) {
        return null;
    }

    return (
        <div className="dashboard-container">
            <div className="content-container">
                <div style={{ marginTop: '50px' }}>
                    <CommonTable headerTitle={['No', '예약번호', '아이디', '작업종류', '주소', '요청일자', '요청시간', '등록시간']}>
                        {
                            // reserveList.slice(items * (page - 1), items * (page - 1) + items).map((reserve, index) => {
                            reserveList.map((reserve, index) => {
                                return (
                                    <CommonTableRow key={index} idx={reserve.idx} beforePage={'/reservation'} kind={'reservation'}>
                                        <CommonTableColumn>{reserveCount - ((page - 1) * 10) - index}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.email}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.user_id}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.working_kind}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.address}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.work_date}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.work_time}</CommonTableColumn>
                                        <CommonTableColumn>{formatDate(reserve.date)}</CommonTableColumn>
                                    </CommonTableRow>
                                )
                            })
                        }
                    </CommonTable>
                </div>
                <PaginationBox>
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={items}
                        totalItemsCount={reserveCount}
                        pageRangeDisplayed={10}
                        onChange={hadlePageChange}>
                    </Pagination>
                </PaginationBox>
            </div >
        </div >
    );
}

const PaginationBox = styled.div`
  .pagination { display: flex; justify-content: center; margin-top: 15px;}
  ul { list-style: none; padding: 0; }
  ul.pagination li {
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid #e2e2e2;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem; 
  }
  ul.pagination li:first-child{ border-radius: 5px 0 0 5px; }
  ul.pagination li:last-child{ border-radius: 0 5px 5px 0; }
  ul.pagination li a { text-decoration: none; color: #337ab7; font-size: 1rem; }
  ul.pagination li.active a { color: white; }
  ul.pagination li.active { background-color: #337ab7; }
  ul.pagination li a:hover,
  ul.pagination li a.active { color: blue; }
`

export default TodayReserve;